import React from 'react';
import { Stack, Typography } from '@mui/material';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';
import { formatToLocalDateTime } from '../../../utils/dateFormatter';
import { getYearsMonthsDiff } from '../../../utils/dateDiff';
import Box from '@mui/material/Box';
import CopyButton from '../../common/controls/CopyButton';
import PersonIcon from '@mui/icons-material/Person'; 
import { ProfilePicture } from '../display/ProfilePicture';
import EditIcon from '@mui/icons-material/Edit';
import { useAuth } from '../../../hooks/useAuth';
import RequirePermission from '../../RequirePermission';
import { SUB_MODULES } from '../../../constants/subModulesConstants';

export default function PetView({
    handleEditPet,
    open, 
    onClose, 
    pet = null
}) {

    const { role, isAuthenticated } = useAuth();

    const handleClose = () => onClose();

    const handleEditClick = () => {
        handleEditPet(pet);
    };

    if (!pet) {
        return (
            <></>
        );
    }

    return (
        <React.Fragment>
        <Dialog onClose={handleClose} open={open} disableRestoreFocus>
            <DialogTitle>{role === 'guest' ? "Your Pet's Info" : "Pet Details"}</DialogTitle>
            <DialogContent dividers>
                <ProfilePicture pet={pet} />
                <Typography variant="body2" sx={{ mb: 0, color: 'gray' }}>Name</Typography>
                <Typography variant="body1" sx={{ mt: 0 }}>{pet.name}</Typography>
                {pet.deceased ?
                <Typography color="error" variant="body2" sx={{ mt: 0 }}>+deceased</Typography>
                : null}

                <Typography variant="body2" sx={{ mb: 0, color: 'gray' }}>Species</Typography>
                <Typography variant="body1" sx={{ mt: 0 }}>{pet.species ? pet.species : pet.speciesLookup?.label}</Typography>

                <Typography variant="body2" sx={{ mb: 0, color: 'gray' }}>Breed</Typography>
                <Typography variant="body1" sx={{ mt: 0 }}>{pet.breed}</Typography>
        
                <Typography variant="body2" sx={{ mb: 0, color: 'gray' }}>Birthdate</Typography>
                <Typography variant="body1" sx={{ mt: 0 }}>{`${pet?.birthdate || ""}`}{pet.birthdate ? " | " : ""}{pet.birthdate ? getYearsMonthsDiff(pet.birthdate) : ""}</Typography>

                <Typography variant="body2" sx={{ mb: 0, color: 'gray' }}>Gender</Typography>
                <Typography variant="body1" sx={{ mt: 0 }}>{pet.gender}</Typography>

                <Typography variant="body2" sx={{ mb: 0, color: 'gray' }}>Neutered</Typography>
                <Typography variant="body1" sx={{ mt: 0 }}>{pet.neutered ? "Yes" : "No"}</Typography>

                <Typography variant="body2" sx={{ mb: 0, color: 'gray' }}>Neutered Date</Typography>
                <Typography variant="body1" sx={{ mt: 0 }}>{pet.neutered_date ? pet.neutered_date : "(none)"}</Typography>

                <Typography variant="body2" sx={{ mb: 0, color: 'gray' }}>Microchip SN</Typography>
                <Typography variant="body1" sx={{ mt: 0 }}>{pet.microchip_sn || "(none)"}</Typography>

                <Typography variant="body2" sx={{ mb: 0, color: 'gray' }}>Created</Typography>
                <Typography variant="body2" sx={{ mt: 0 }}>{formatToLocalDateTime(pet.createdAt)}</Typography>

                <Typography variant="body2" sx={{ mb: 0, color: 'gray' }}>Last Updated</Typography>
                <Typography variant="body2" sx={{ mt: 0 }}>{formatToLocalDateTime(pet.updatedAt)}</Typography>

                <br />
                <Stack direction="row" spacing={1} alignItems="center">
                    <PersonIcon fontSize='small' />
                    <Typography variant="h6">Owner</Typography>
                </Stack>
                <Typography variant="body1" sx={{ mb: 0, }}>{`${pet.owner.first_name} ${pet.owner.last_name}`}</Typography>
                <Box display="flex" alignItems="center">
                    <Typography variant="body2" sx={{ mt: 0 }}>{pet.owner.email}</Typography>
                    <CopyButton text={pet.owner.email} />
                </Box>
                <Box display="flex" alignItems="center">
                    <Typography variant="body2" sx={{ mt: 0 }}>{pet.owner.contact_number}</Typography>
                    <CopyButton text={pet.owner.contact_number} />
                </Box>
                {pet.owner.address ?
                <Box display="flex" alignItems="center">
                    <Typography variant="body2" sx={{ mt: 0 }}>{pet.owner.address}</Typography>
                    <CopyButton text={pet.owner.address} />
                </Box>
                : null }
            </DialogContent>
            <DialogActions>
                <RequirePermission
                  subModuleName={SUB_MODULES.PETS}
                  minAccessLevel={2}
                >
                  <Button onClick={handleEditClick}>
                      <EditIcon />
                  </Button>
                </RequirePermission>
                <div style={{flex: '1 0 0'}} />
                <Button onClick={handleClose}>{role === 'guest' ? "Next" : "Close"}</Button>
            </DialogActions>
        </Dialog>
        </React.Fragment>
    );
}